import { useEffect, useState } from "react";
import { enviarImagemCidade } from "../../../services/cidades";
import { getImageUrl } from "../../../utils/media";
import FormActions from "../FormActions/FormActions";
import DialogShell from "./DialogShell";

const MAX_IMAGE_SIZE = 15 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png"];
const EMPTY_MEMBER = { name: "", role: "", photoUrl: "", photoPublicId: "" };

export default function MemberDialog({ open, member, onCancel, onSave }) {
  const [draft, setDraft] = useState(EMPTY_MEMBER);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setDraft({ ...EMPTY_MEMBER, ...(member || {}) });
    setError("");
  }, [member, open]);

  if (!open) return null;

  const uploadPhoto = async (file) => {
    if (!file) return;
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      setError("Selecione uma imagem JPG ou PNG.");
      return;
    }
    if (file.size > MAX_IMAGE_SIZE) {
      setError("A imagem deve ter no máximo 15 MB.");
      return;
    }
    setUploading(true);
    setError("");
    try {
      const uploaded = await enviarImagemCidade(file);
      setDraft((current) => ({ ...current, photoUrl: uploaded.url, photoPublicId: uploaded.public_id || "" }));
    } catch (uploadError) {
      setError(uploadError?.response?.data?.error || "Não foi possível enviar a imagem. Tente novamente.");
    } finally {
      setUploading(false);
    }
  };

  const submitMember = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const name = draft.name.trim();
    const role = draft.role.trim();
    if (!name || !role) {
      setError("Informe o nome e o cargo do membro.");
      return;
    }
    onSave({ ...draft, name, role });
  };

  const photoUrl = getImageUrl(draft.photoUrl);

  return (
    <DialogShell className="admin-dialog--member" labelledBy="admin-member-title" onClose={uploading ? undefined : onCancel}>
      <h2 id="admin-member-title" className="admin-dialog__sr-only">{member ? "Editar membro" : "Adicionar membro"}</h2>
      <form className="admin-member-form" onSubmit={submitMember}>
        <label className="admin-member-form__photo">
          {photoUrl ? <img src={photoUrl} alt="Prévia do membro" /> : <span className="admin-member-form__placeholder" aria-hidden="true">Imagem</span>}
          <span className="admin-member-form__upload">{uploading ? "Enviando..." : photoUrl ? "Trocar foto" : "Adicionar foto"}</span>
          <input type="file" accept=".jpg,.jpeg,.png,image/jpeg,image/png" disabled={uploading} onChange={(event) => {
            uploadPhoto(event.target.files?.[0]);
            event.target.value = "";
          }} />
        </label>
        <label className="admin-member-form__field admin-member-form__field--name">
          <span>Nome</span>
          <input type="text" value={draft.name} placeholder="Nome" onChange={(event) => setDraft((current) => ({ ...current, name: event.target.value }))} required />
        </label>
        <label className="admin-member-form__field">
          <span>Cargo</span>
          <input type="text" value={draft.role} placeholder="Cargo" onChange={(event) => setDraft((current) => ({ ...current, role: event.target.value }))} required />
        </label>
        {error && <p className="admin-member-form__error" role="alert">{error}</p>}
        <FormActions
          onCancel={onCancel}
          saveType="submit"
          disabled={uploading}
        />
      </form>
    </DialogShell>
  );
}
